import React, {Component} from 'react'
import Header4 from 'src/components/Header/Header4'
import {Menu, List, Divider, Badge, Avatar, Tag, Button, Popconfirm} from 'antd';
import icon_avatar from './img/icon_avatar.png'
import Axios from 'axios'
import {connect} from 'react-redux';
import './QAmessage.css'
import {getUnReadMsg} from 'src/service/loginaction_yunguan';
import {DeleteOutlined} from "@ant-design/icons";
import axios from "axios";
import {message} from "antd";

class QAmessage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectType: 'mypost',
            dataList: [],
            currentPage: 1,
            totalPage: 1,
            confirmDelete: false
        }
    }

    componentDidMount() {
        this.loaddata()
    }

    loaddata = async (selectType = this.state.selectType, currentPage = this.state.currentPage) => {
        let dataList = []
        let temp = {}
        let pages = 0
        switch (selectType) {
            case 'mypost':
                temp = await Axios.get(global.url.wd + "/postV2/selectByKeyword?userId=" + this.props.user.userId + "&page=" + currentPage)
                if (temp.data.code = '200') {
                    dataList = temp.data.payload.records
                    pages = temp.data.payload.total
                } else
                    throw temp.data.message
                break;
            case 'relative':
                temp = await Axios.get(global.url.wd + "/msg/messageR?limit=10&page=" + currentPage + "&userId=" + this.props.user.userId)
                if (temp.data.code = '200') {
                    dataList = temp.data.payload.records
                    pages = temp.data.payload.pages
                } else
                    throw temp.data.message
                break;
            default:
                break;
        }
        this.setState({dataList: dataList, selectType: selectType, totalPage: pages, currentPage: currentPage})
    }

    _switchPage = async (page) => {
        this.loaddata(null, page)
    }

    _switchType = ({item, key, keyPath, domEvent}) => {
        let selectType = key
        this.loaddata(key)
    }

    _jumpPage = async (item) => {
        await Axios.get(global.url.wd + '/msg/msgDetails?commentId=' + item.commentId + '&msgId=' + item.msgId)
        await getUnReadMsg(this.props.user.userId)
        this.props.history.push({
            pathname: '/Q&ADetail/' + item.postId,
            state: item
        })
    }

    _deleteMessage = (item) => {
        console.log("message:", item)
        axios.delete(global.url.wd + `/postV2/delete?postId=${item.postId}`).then(
            res => {
                if (res.data.code === '200') {
                    message.success("删除成功！");
                    this.loaddata();
                }else {
                    message.error(res.data.message);
                }
            }
        )
    }
    _renderPost = item => {
        if (this.state.selectType === 'mypost') {
            return (
                <List.Item
                    key={item.postId}
                    onClick={() => this.props.history.push({
                        pathname: '/Q&ADetail/' + item.postId,
                        state: item
                    })}
                >
                    <div className='postTitleContainer'>
                        <span className='postTitle'>{item.postTitle}</span>
                        {/*<div className='postType'>*/}
                        {/*    <span className='postTypeText'>*/}
                        {/*        {item.postType}*/}
                        {/*    </span>*/}
                        {/*</div>*/}
                        <Popconfirm
                            open={this.state.confirmDelete}
                            onCancel={(event) => {
                                event.stopPropagation();
                                this.setState({confirmDelete: false});
                            }}
                            onConfirm={(event) => {
                                event.stopPropagation();
                                this._deleteMessage(item);
                            }}
                            title={"删除后无法恢复，确认删除？"}>
                            <Button 
                            danger type="text" icon={<DeleteOutlined/>}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        this.setState({confirmDelete: true})
                                    }}
                                    size="small"
                                    style={{fontSize: "1.4rem"}}
                                // style={{height:"20px",width:"40px"}}
                            >删除</Button>
                        </Popconfirm>
                    </div>
                    <p className='postContent'>
                        {item.postContent}
                        <Tag color={"blue"} className="post_type"> {item.postType}</Tag>
                    </p>
                    <Divider className='postDivider'/>
                    <div className='postFooter'>
                        <div className='postFooter1'>
                            <div className='postEditor'>作者：{item.userName}</div>
                            <div className='postTime'>{item.createdTime.substring(0, 10)}</div>
                        </div>
                        <div className='postFooter2'>
                            <div className='postNum'>{item.viewCount}<span className='postPot'>浏览量</span></div>
                            <div className='postNum'>{item.comments}<span className='postPot'>评论</span></div>
                        </div>
                    </div>
                </List.Item>
            )
        } else {
            return (
                <div key={item.msgId} onClick={() => this._jumpPage(item)}>
                    <div className='M-relative-detail'>
                        <Avatar src={item.avatar ? global.yunguanChangeUrl + item.avatar : icon_avatar}
                                className='M-relative-useravatar'/>
                        <span className='M-relative-username'>{item.sendUserName}</span>
                        <Badge dot={!item.isread} size="small">
                            <span className='M-relative-span'>评论了您</span>
                        </Badge>
                    </div>
                    <List.Item>
                        <div className='postTitleContainer'>
                            <span className='postTitle'>{item.postTitle}</span>
                            <div className='postType'>
                                <span className='postTypeText'>
                                    {item.postType}
                                </span>
                            </div>
                        </div>
                        <p className='postContent'>{item.commentBody}</p>
                        <Divider className='postDivider'/>
                        <div className='postFooter'>
                            <div className='postFooter1'>
                                <div className='postEditor'>作者：{item.postUserName}</div>
                                <div className='postTime'>{item.time.substring(0, 10)}</div>
                            </div>
                        </div>
                    </List.Item>
                </div>
            )
        }

    }


    render() {
        return (
            <div>
                <Header4></Header4>
                <div className='QAMain'>
                    <div className='QAMContent'>
                        <div className='QAMContentType'>
                            <Menu mode="vertical" defaultSelectedKeys={['mypost']} id='QAMenu'
                                  onClick={this._switchType}>
                                <Menu.Item key="mypost" id='QAMenuItem' className="QAMenu">
                                    我的帖子
                                </Menu.Item>
                                <Menu.Item key="relative" id='QAMenuItem' className="QAMenu">
                                    相关评论
                                </Menu.Item>
                            </Menu>
                        </div>
                        <div className='QAContentList'>
                            <div onClick={() => this.props.history.goBack()}>
                                <span className='M-back'>{"<  返回上一级"}</span>
                            </div>
                            <div className='listContainer'>
                                <List
                                    itemLayout="vertical"
                                    size="large"
                                    dataSource={this.state.dataList}
                                    renderItem={this._renderPost}
                                    split={false}
                                    pagination={{
                                        onChange: page => {
                                            console.log(page);
                                        },
                                        pageSize: 10,
                                        totalPage: this.state.totalPage
                                    }}
                                >
                                </List>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapState = (state) => ({
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS()
})
const mapDispatch = () => ({})
export default connect(mapState, mapDispatch)(QAmessage);
